import './css/style.scss'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import http from './utils/ajax'

import Vant from 'vant'
import '@/plugins/index'
import 'vant/lib/index.css'
import i18n from './lang'

import './icons'


Vue.prototype.$http = http
Vue.config.productionTip = false

Vue.use(Vant)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
